import namespace from './namespace';

export default {
	[namespace.mutations.UPDATE_HIERARCHY_STATE] (state, hierarchy) {
		state[namespace.state.HIERARCHY_STATE] = hierarchy;
	},
	[namespace.mutations.SET_AVAILABLE_JIRA_VALUES] (state, availableJiraValues) {
		availableJiraValues.forEach(function(value) {
			value.regularTitle = value.LabelA + ' / ' + value.LabelB;
			value.invertedTitle = value.LabelB + ' / ' + value.LabelA;
		});
		availableJiraValues.unshift({regularTitle: 'None', invertedTitle: 'None', JiraLinkType: 0, LabelA: '', LabelB: ''});
		state[namespace.state.AVAILABLE_JIRA_VALUES] = availableJiraValues;
	},
	[namespace.mutations.SET_IS_EPIC_NAME_MAPPED] (state, isEpicNameMapped) {
		state[namespace.state.IS_EPIC_NAME_MAPPED] = isEpicNameMapped;
	},
	[namespace.mutations.SET_IS_EPIC_TYPE_MAPPED] (state, isEpicTypeMapped) {
		state[namespace.state.IS_EPIC_TYPE_MAPPED] = isEpicTypeMapped;
	},
	[namespace.mutations.SET_IS_NEXT_GEN] (state, isNextGen) {
		state[namespace.state.IS_NEXT_GEN] = isNextGen;
	},
	[namespace.mutations.DISABLE_VIEW] (state) {
		state[namespace.state.WAITING_FOR_RESPONSE] = true;
	},
	[namespace.mutations.ENABLE_VIEW] (state) {
		state[namespace.state.WAITING_FOR_RESPONSE] = false;
	},
	[namespace.mutations.UPDATE_JIRA_LINK] (state) {
		const hierarchyState = state[namespace.state.HIERARCHY_STATE];
		if (hierarchyState.Enabled !== undefined) {
			const selectedJiraLink = state[namespace.state.AVAILABLE_JIRA_VALUES].find(jiraLink => jiraLink.JiraLinkType === hierarchyState.JiraLinkId);
			if(selectedJiraLink === undefined || selectedJiraLink === null){
				state[namespace.state.SELECTED_JIRA_LINK] = '';
			} else {
				state[namespace.state.SELECTED_JIRA_LINK] = hierarchyState.JiraLinkIsInverted ? selectedJiraLink.invertedTitle : selectedJiraLink.regularTitle;
			}
		}
	}
};


// WEBPACK FOOTER //
// ./src/store/modules/hierarchy/mutations.js